import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import type { InspiredGlobalStudyPlatformApiModelsAccountStudent as Student } from 'shared/api/gsp';

export type StudentState = Student | null;

const initialState: StudentState = null;

export const studentSlice = createSlice<
  StudentState,
  SliceCaseReducers<StudentState>
>({
  name: 'student',
  initialState,
  reducers: {
    setStudent: (_, action: PayloadAction<StudentState>) => action.payload,
  },
});

export const { actions: studentActions, reducer: studentReducer } =
  studentSlice;
